// Hook: utworzenie nowej wersji oferty (kopia aktualnej).
// POST /sales-crm/clients/:cid/offers/:oid/versions

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

type IResponse = ICommandResponseSuccess & {
  data?: { newVersionId?: number; new_version_id?: number };
};

const postSalesCrmOfferVersion = (clientId: number, offerId: string): Promise<IResponse> =>
  axios.post(`/sales-crm/clients/${clientId}/offers/${offerId}/versions`, {});

export const usePostSalesCrmOfferVersion = (
  clientId: number,
  offerId: string,
  options?: UseMutationOptions<IResponse, IError, void>
) =>
  useMutation(() => postSalesCrmOfferVersion(clientId, offerId), options);
